var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.662,
    height: 22.662,
    viewBox: "0 0 22.662 22.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M5.073,22.663H.374V7.532h4.7ZM2.721,5.469A2.734,2.734,0,1,1,5.442,2.722,2.744,2.744,0,0,1,2.721,5.469ZM22.657,22.663H17.969V15.3c0-1.755-.035-4.006-2.443-4.006-2.443,0-2.817,1.907-2.817,3.88v7.492H8.016V7.532h4.506V9.6h.066a4.937,4.937,0,0,1,4.445-2.443c4.755,0,5.629,3.131,5.629,7.2v8.311Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIn);
export default __webpack_public_path__ + "static/media/linkedin-in.eb7b949c69dc0176402da3cb107efa87.svg";
export { ForwardRef as ReactComponent };